import React, { useState } from 'react';
import { Switch } from 'legacy-packages/ft-cb';
import './index.scss';

const SwitchField = (props) => {
  const { fieldName, onChange, value } = props;

  const [switchValue, setSwitchValue] = useState(value);

  const handleToggle = (checked) => {
    setSwitchValue(checked ? 'on' : 'off');
    onChange(checked ? 'on' : 'off');
  };

  return (
    <Switch
      fieldName={fieldName}
      toggleCallback={(checked) => handleToggle(checked)}
      states={{
        on: {
          icon: 'switch-on',
          iconClassName: 'switch-field__switch-icon switch-field__switched-on',
        },
        off: {
          icon: 'switch-off',
          iconClassName: 'switch-field__switch-icon switch-field__switched-off',
        },
      }}
      className="switch-field__toggle-button"
      value={switchValue}
    />
  );
};

SwitchField.displayName = 'SwitchField';

export default SwitchField;
